<template>
  <table-component
    ref="table"
    :data="paymentData"
    :show-filter="false"
    table-class="table"
  >
    <table-column
      :label="$t('payments.date')"
      sort-as="payment_date"
      show="formattedPaymentDate"
    />
    <table-column
      :label="$t('payments.invoice_num')"
      sort-as="invoice_id"
      show="payable.reference_number"
    />
    <table-column
      :label="$t('payments.payment_num')"
    >
      <template slot-scope="row">
        {{ row.payable.rtgs_number || row.payment_number }}
      </template>
    </table-column>
    <table-column
      :label="$t('general.sent')"
    >
      <template slot-scope="row">
        <p v-if="row.sent_stakeholder">
          <span v-if="row.sent_stakeholder.details.company && row.sent_stakeholder.details.company.name">
            {{ row.sent_stakeholder.details.company.name }}
          </span>
          <!-- {{ row.sent_stakeholder.details.user.name }} -->
        </p>
      </template>
    </table-column>
    <table-column
      :label="$t('general.received')"
    >
      <template slot-scope="row">
        <p v-if="row.receiver_stakeholder">
          <span v-if="row.receiver_stakeholder.details.company && row.receiver_stakeholder.details.company.name">
            {{ row.receiver_stakeholder.details.company.name }}
          </span>
          <!-- {{ row.receiver_stakeholder.details.user.name }} -->
        </p>
      </template>
    </table-column>
    <table-column
      :label="$t('payments.payment_mode')"
      show="payment_mode"
    />

    <table-column
      :label="$t('payments.amount')"
    >
      <template slot-scope="row">
        <span>{{ $t('payments.amount') }}</span>
        <div v-if="row.sent_stakeholder.details.currency" v-html="$utils.formatMoney(row.amount, row.sent_stakeholder.details.currency)" />
        <div v-else v-html="$utils.formatMoney(row.amount, row.customer.currency)" />
      </template>
    </table-column>
    <table-column
      :label="$tc('payments.payment_type',1)"
      show="payment_type"
    />
  </table-component>
</template>
<script>
export default {
  props: {
    paymentData: { default: () => [], type: [Array, Function] },
    tableDivId: {default: '', type: String }
  }
}
</script>
